import React from 'react';

import Button from '~/components/button';
import InputField from '~/components/inputs/input-field';
import { Form, Field } from '~/components/form';
import { valid, required, email } from '~/utils/validation';

const ForgotPasswordForm = ({ onSubmit }) => {
  return (
    <Form onSubmit={onSubmit} validate={validate}>
      {({ isSubmitting }) => (
        <>
          <Field
            label="Email address"
            name="email"
            type="email"
            component={InputField}
            autoComplete="email"
          />
          <Button type="submit" isLoading={isSubmitting} fullWidth>
            Send me a sign in link
          </Button>
        </>
      )}
    </Form>
  );
};

function validate(formValues) {
  return {
    email: valid(required(), email())(formValues.email),
  };
}

export default ForgotPasswordForm;
